import type { RegisteredComponent } from '@builder.io/sdk-vue'

import TrailButton from '~/components/TrailDS/Button__Builder'

export const TrailDSComponents: RegisteredComponent[] = [TrailButton]
